export const sharingSettingsState = {
  sharingSettingsData: null,
  rssData:[]
}
